import { SimplePageContentWrapper, SimplePageLayout, SimplePageHeader } from '@flexinet/ui-components';
import { RecordsTable } from '../../orders/tables/RecordsTable';
import { ReportPageNavigation } from '../navigation/ReportPageNavigation';

export const OrdersReportPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<SimplePageHeader title="Orders Report" />}
      pageNavigation={<ReportPageNavigation reportName="Orders Report" />}
    >
      <SimplePageContentWrapper>
        <RecordsTable />
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};